import * as React from "react";
import "../../../../sass/main.scss";
import "purecss/build/base-min.css";
import "purecss/build/grids-min.css";
const d3 = require("d3-format");

export class ChoroplethLegend extends React.Component<any, any> {
  formatText(val: number) {
    const setup = ".3s";
    const formatter = d3.format(setup);
    let txt = formatter(val).replace(/(\.0+)(?=[a-zA-Z])|(\.0+)(?!\d)/, "$1$2");

    return txt;
  }
  render() {
    const minVal = this.props.min;
    const maxVal = this.props.max;
    const interval = (maxVal - minVal) / 6;

    return (
      <div style={{ display: "inline-block" }}>
        <div
          style={{
            textAlign: "center",
            marginTop: 2,
            paddingTop: 10,
            paddingBottom: 3,
            paddingLeft: 12,
            paddingRight: 12,
            backgroundColor: "white",
            marginRight: 5
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width={400} height={10}>
            <defs>
              <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%">
                <stop
                  offset="0%"
                  style={{ stopColor: "rgb(214, 239, 244)", stopOpacity: 1 }}
                />
                <stop
                  offset="16.7%"
                  style={{ stopColor: "rgb(214, 239, 244)", stopOpacity: 1 }}
                />

                <stop
                  offset="16.7%"
                  style={{ stopColor: "rgb(171, 222, 232)", stopOpacity: 1 }}
                />
                <stop
                  offset="33.4%"
                  style={{ stopColor: "rgb(171, 222, 232)", stopOpacity: 1 }}
                />

                <stop
                  offset="33.4%"
                  style={{ stopColor: "rgb(128, 205, 221)", stopOpacity: 1 }}
                />
                <stop
                  offset="50.1%"
                  style={{ stopColor: "rgb(128, 205, 221)", stopOpacity: 1 }}
                />

                <stop
                  offset="50.1%"
                  style={{ stopColor: "rgb(86, 188, 209)", stopOpacity: 1 }}
                />
                <stop
                  offset="66.8%"
                  style={{ stopColor: "rgb(86, 188, 209)", stopOpacity: 1 }}
                />

                <stop
                  offset="66.8%"
                  style={{ stopColor: "rgb(43, 171, 198)", stopOpacity: 1 }}
                />
                <stop
                  offset="83.5%"
                  style={{ stopColor: "rgb(43, 171, 198)", stopOpacity: 1 }}
                />

                <stop
                  offset="83.5%"
                  style={{ stopColor: "rgb(0, 154, 186)", stopOpacity: 1 }}
                />
                <stop
                  offset="100%"
                  style={{ stopColor: "rgb(0, 154, 186)", stopOpacity: 1 }}
                />
              </linearGradient>
            </defs>
            <rect
              x="0"
              y="0"
              width="100%"
              height="100%"
              fill="url(#lgrad)"
              rx={3}
              ry={3}
            />
          </svg>
          <div className="pure-g" style={{ width: "100%", fontSize: 11 }}>
            <div className="pure-u-xs-1-6"></div>
            <span className="pure-u-xs-1-6" style={{ textAlign: "left" }}>
              {this.formatText(minVal + interval)}
            </span>
            <span className="pure-u-xs-1-6" style={{ textAlign: "left" }}>
              {this.formatText(minVal + 2 * interval)}
            </span>
            <span className="pure-u-xs-1-6" style={{ textAlign: "left" }}>
              {this.formatText(minVal + 3 * interval)}
            </span>
            <span className="pure-u-xs-1-6" style={{ textAlign: "left" }}>
              {this.formatText(minVal + 4 * interval)}
            </span>
            <span className="pure-u-xs-1-6" style={{ textAlign: "left" }}>
              {this.formatText(maxVal)}
            </span>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/core/Chart/Choropleth/ChoroplethLegend.tsx